export default __webpack_public_path__ + "static/media/0258.41f730d3.jpg";